<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>
<ng-container *ngIf="loadInfo && recordMedicalHerded">
  <p class="text-info mb-sm">Selecciona las enfermedades que padecen tus parientes biológicos o hayan padecido en algún momento.</p>
  <div class="tw-p-5 tw-rounded-md tw-mb-5 tw-border tw-border-solid tw-border-gray-100" *ngFor="let category of diseaseCategories; index as i">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <label class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img [src]="'./../../../assets/images/icons/' + category.icon" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">{{ category.name }}</p>
          </div>
        </label>
      </div>
      <nz-collapse nzGhost class="tw-w-full tw-shadow-none">
        <ng-template #header>
          <div class="tw-flex tw-items-center tw-h-4 tw-w-full tw-pr-7">
            <p class="tw-text-gray-900 tw-text-sm truncate">
              Enfermedades relacionadas. <span *ngIf="!collapse.nzActive" @fadeInAnimation class="tw-text-gray-600">{{ category.diseases | stringifyArray: 'name' }}</span>
            </p>
          </div>
        </ng-template>
        <nz-collapse-panel
          #collapse
          [nzHeader]="header">
          <p class="text-info tw-ml-4 tw-mt-3">{{ category.diseases && category.diseases.length > 0 ? 'Por favor selecciona las enfermedades presentadas por el paciente.' : 'No se han establecido enfermedades en la categoría.' }}</p>
          <div nz-col [nzXs]="24" *ngFor="let disease of category.diseases; index as j">
            <label nz-checkbox class="tw-mb-3" [(ngModel)]="disease.active" [nzDisabled]="disableForm" (ngModelChange)="checkedDiseaseChange($event, i, j)">{{ disease.name }}</label>
            <ng-container *ngIf="disease.active">
              <div nz-row [nzGutter]="[30, 30]">
                <div nz-col [nzXs]="24">
                  <form #formDisease="ngForm">
                    <div class="input-label-form">Parientes biológicos</div>
                    <div class="tw-flex tw-gap-4 tw-flex-wrap sm:tw-items-center">
                      <span
                        *ngFor="let family of disease.options; index as k"
                        class="tw-flex tw-justify-between sm:tw-justify-start tw-items-center tw-w-full sm:tw-w-fit tw-py-1 tw-px-2 tw-bg-gray-100 tw-rounded"
                        [ngClass]="{
                          'tw-bg-green-100': family.quantity > 0 && !disease.required,
                          'tw-bg-red-100': disease.required
                        }"
                      >
                        {{family.relation }}
                        <nz-input-number
                          [nzMin]="0"
                          [nzMax]="family.max || 9999"
                          [nzStep]="1"
                          style="max-width: 100px;"
                          class="tw-ml-4"
                          nzPlaceHolder="Cantidad"
                          [name]="'quantity'+disease._id+i+j+k"
                          [nzDisabled]="disableForm"
                          [(ngModel)]="family.quantity"
                          (ngModelChange)="changeQuantity($event, disease, family)"></nz-input-number>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </ng-container>
          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>

  <div class="d-flex justify-content-end" *ngIf="!disableForm && !isInnerRecord">
    <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
  </div>
</ng-container>
